export const APP_NAME = 'Skin Forge';

export const API_URL = process.env.NODE_ENV === 'development'
	? 'http://localhost:7054/api'
	: process.env.REACT_APP_API_URL;

const config = {
	imageBaseUrl: process.env.REACT_APP_IMAGE_BASE_URL || 'http://localhost:7054',
	isDevelopment: process.env.NODE_ENV === 'development',
	isProduction: process.env.NODE_ENV === 'production',
	getImageUrl: (path) => {
		if (!path) return '';

		console.log(API_URL, path, process.env.REACT_APP_IMAGE_BASE_URL);

		// Если это Steam URL, удаляем префикс API и возвращаем чистый URL
		if (path.includes('steamcommunity-a.akamaihd.net')) {
			const apiPrefix = process.env.REACT_APP_API_URL || 'http://localhost:7054/api';
			return path.replace(apiPrefix, '');
		}

		// Если это уже полный URL, возвращаем как есть
		if (path.startsWith('http://') || path.startsWith('https://')) {
			return path;
		}

		// Для локальных файлов используем imageBaseUrl
		const cleanPath = path.startsWith('/') ? path.slice(1) : path;
		const baseUrl = process.env.REACT_APP_IMAGE_BASE_URL || 'http://localhost:7054';
		return `${baseUrl}/${cleanPath}`;
	}
};

export default config; 